import { render, staticRenderFns } from "./trainingTabs.vue?vue&type=template&id=01ef2208"
import script from "./trainingTabs.vue?vue&type=script&lang=js"
export * from "./trainingTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports